import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import './CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { newProduct } from '../Models/ProductsModel';
import CustomAlert from '../CustomAlert';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { dateFormatter, sleep } from '../Models/CommonFunc'
import { Helmet } from 'react-helmet';
import { createProductDocument, createUserDocument } from '../../Backend/firebase/product';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreateProduct() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [ProductDescription, setProductDescription] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [ExpiryDate, setExpiryDate] = useState(new Date())
    const [isEnabledProductSize, setIsEnabledProductSize] = useState(false);
    const { userData } = CheckUserProvider();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        const value = convertToRaw(ProductDescription.getCurrentContent());
        // if (ProductDescription.getCurrentContent().hasText()) {
            newProduct.userId = userData.uid;
            newProduct.ProductName = data.ProductName;
            newProduct.Compostions = data.Compostions;
            newProduct.PackagingType = data.PackagingType;
            newProduct.ProductType = data.ProductType;
            newProduct.MRP = data.MRP;
            newProduct.PackagingSize = data.ProductSize;
            newProduct.ProductSize = data.ProductSize;
            newProduct.OthersProductSize = isEnabledProductSize ? data.OthersProductSize : '';
            newProduct.HSNCode = data.HSNCode;
            newProduct.GSTClass = data.GSTClass;
            newProduct.Discount = data.Discount;
            newProduct.ExpiryDate = ExpiryDate;
            newProduct.BatchNo = data.BatchNo;
            newProduct.ProductDescription = String(JSON.stringify(value));
            newProduct.ProductStatus = 'New';
            try {
                var product = createProductDocument(newProduct);
                if (product) {
                    setNotificationMessage('Product created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    reset();
                    setProductDescription(EditorState.createEmpty());
                    setIsLoading(false);
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-product');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-product');
            }
        // } else {
        //     setNotificationMessage("Please enter product description!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/all-products';
    }

    const onEditorStateChange = (editorState) => {
        setProductDescription(editorState);
    };


    const handleExpiryDateChange = (e) => {
        setExpiryDate(dateFormatter(e.target.value));
    }

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating new product page." />
                    <title>Create new product | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                Product Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductName })}
                                    name="ProductName" autoComplete="none"
                                    ref={register({ required: 'Please enter product title!' })} />
                                <small className="form-text text-danger">{errors.ProductName && errors.ProductName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Compostions <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Compostions })}
                                    name="Compostions" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter product Compostions!' })} />
                            </div>
                            <div className="col-md-4 mb-2">
                                Product Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                {/* <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductType })}
                                    name="ProductType" autoComplete="none"
                                    ref={register({ required: 'Please enter Package Type!' })}  /> */}
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.ProductType })} 
                                    aria-label="Default select example"
                                    name="ProductType" ref={register({
                                        required: 'Please select Product Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Product Type!'
                                        }
                                    })} defaultValue="Select Product Type" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Tablet'}>{'Tablet'}</option>
                                    <option value={'Capsule'}>{'Capsule'}</option>
                                    <option value={'Injection'}>{'Injection'}</option>
                                    <option value={'Powder'}>{'Powder'}</option>
                                    <option value={'Oil'}>{'Oil'}</option>
                                    <option value={'Gel'}>{'Gel'}</option>
                                    <option value={'Capsule'}>{'Capsule'}</option>
                                    <option value={'Ointment'}>{'Ointment'}</option>
                                    <option value={'Syrup'}>{'Syrup'}</option>
                                    <option value={'Cream'}>{'Cream'}</option>
                                    <option value={'Spray'}>{'Spray'}</option>
                                    <option value={'Gelatin'}>{'Gelatin'}</option>
                                    <option value={'Other'}>{'Other'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.ProductType && errors.ProductType.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Packaging Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.PackagingType })} 
                                    aria-label="Default select example"
                                    name="PackagingType" ref={register({
                                        required: 'Please select Packaging Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Packaging Type!'
                                        }
                                    })} defaultValue="Select Packaging Type" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Bottle'}>{'Bottle'}</option>
                                    <option value={'Bucket'}>{'Bucket'}</option>
                                    <option value={'Box'}>{'Box'}</option>
                                    <option value={'Can'}>{'Can'}</option>
                                    <option value={'Drum'}>{'Drum'}</option>
                                    <option value={'Gallon'}>{'Gallon'}</option>
                                    <option value={'Gram'}>{'Gram'}</option>
                                    <option value={'Jar'}>{'Jar'}</option>
                                    <option value={'Kit'}>{'Kit'}</option>
                                    <option value={'Pack'}>{'Pack'}</option>
                                    <option value={'Roll'}>{'Roll'}</option>
                                    <option value={'Set'}>{'Set'}</option>
                                    <option value={'Sample'}>{'Sample'}</option>
                                    <option value={'Strip'}>{'Strip'}</option>
                                    <option value={'Sachet'}>{'Sachet'}</option>
                                    <option value={'PackagingSize'}>{'PackagingSize'}</option>
                                    <option value={'Vial'}>{'Vial'}</option>
                                    <option value={'Others'}>{'Others'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.PackagingType && errors.PackagingType.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Product Size
                                <select 
                                    className={classNames("form-select registerEmp__textbox")} 
                                    aria-label="Default select example"
                                    name="ProductSize" ref={register()} 
                                    onChange={(event)=> {
                                        setIsEnabledProductSize(event.target.value == "Others" ? true : false)
                                    }}
                                    defaultValue="Select Product Size" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'5ml'}>{'5ml'}</option>
                                    <option value={'10ml'}>{'10ml'}</option>
                                    <option value={'40mg'}>{'40mg'}</option>
                                    <option value={'200gm'}>{'200gm'}</option>
                                    <option value={'Others'}>{'Others'}</option>
                                </select>
                                {isEnabledProductSize && <>
                                    Product Size <small>(if not in list)</small> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.OthersProductSize })}
                                        name="OthersProductSize" autoComplete="none"
                                        placeholder="Enter Product Size if not in list"
                                        ref={register({ required: 'Please enter Product Size!' })} />
                                    <small className="form-text text-danger">{errors.OthersProductSize && errors.OthersProductSize.message}</small>
                                </>}
                            </div>
                            <div className="col-md-4 mb-2">
                                MRP <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MRP })}
                                    name="MRP" autoComplete="none"
                                    ref={register({ required: 'Please enter product MRP!' })} />
                                    <small className="form-text text-danger">{errors.MRP && errors.MRP.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Discount(in Percentage) <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Discount })}
                                    name="Discount" autoComplete="none"
                                    ref={register({ required: 'Please enter product Discount!' })} />
                                <small className="form-text text-danger">{errors.Discount && errors.Discount.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                GST Class <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.GSTClass })} 
                                    aria-label="Default select example"
                                    name="GSTClass" ref={register({
                                        required: 'Please select GST Class!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select GST Class!'
                                        }
                                    })} defaultValue="Select GST Class" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Nil'}>{'Nil'}</option>
                                    <option value={'5'}>{'5%'}</option>
                                    <option value={'12'}>{'12%'}</option>
                                    <option value={'18'}>{'18%'}</option>
                                    <option value={'28'}>{'28%'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.GSTClass && errors.GSTClass.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                HSN Code
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="HSNCode" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                Batch No <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.BatchNo })}
                                    name="BatchNo" autoComplete="none"
                                    ref={register({ required: 'Please enter product Discount!' })} />
                                <small className="form-text text-danger">{errors.BatchNo && errors.BatchNo.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Expiry Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="ExpiryDate"
                                    name="ExpiryDate"
                                    value={ExpiryDate}
                                    cssclassName="e-outline"
                                    onChange={(e) => handleExpiryDateChange(e)}
                                    ref={register({ required: 'Please enter Expiry Date!' })}
                                    format="dd/mm/yyyy"
                                />
                                <small className="form-text text-danger">{errors.ExpiryDate && errors.ExpiryDate.message}</small>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                Product Description
                                <div className="createProduct__RictTextEditor">
                                    <Editor name="ProductDescription" 
                                        editorState={ProductDescription} 
                                        onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Create Product'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />
        </>
    )
}

export default CreateProduct

